// src/api/coworkApi.js
//
// Client helpers for the /cowork surface (Hermes agent).
// Mirrors api/chatApi.js but targets the /api/cowork/* endpoints.
// The SSE stream reuses the shared /api/chat/jobs/<jobId>/stream endpoint.

function getAuthToken() {
  return (
    localStorage.getItem("access_token") ||
    localStorage.getItem("token") ||
    sessionStorage.getItem("access_token") ||
    sessionStorage.getItem("token") ||
    ""
  );
}

async function safeText(res) {
  try {
    return await res.text();
  } catch {
    return "";
  }
}

async function apiFetch(path, { method = "GET", body, signal } = {}) {
  const token = getAuthToken();

  const res = await fetch(path, {
    method,
    headers: {
      ...(body ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
    signal,
  });

  if (res.status === 401) {
    const text = await safeText(res);
    const err = new Error(text || "Unauthorized (token expired).");
    err.status = 401;
    throw err;
  }

  if (!res.ok) {
    const text = await safeText(res);
    const err = new Error(text || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }

  if (res.status === 204) return null;

  const contentType = res.headers.get("content-type") || "";
  const raw = await res.text();
  if (!raw) return null;

  if (contentType.includes("application/json")) {
    try {
      return JSON.parse(raw);
    } catch {
      return raw;
    }
  }
  return raw;
}

/* -----------------------------
   Cowork API helpers
   ----------------------------- */

export async function createNewCowork({ signal } = {}) {
  // POST /api/cowork/new
  return apiFetch("/api/cowork/new", { method: "POST", signal });
}

export async function loadCoworkSession(sessionId, { signal } = {}) {
  // GET /api/cowork/session/<sessionId>
  return apiFetch(`/api/cowork/session/${encodeURIComponent(sessionId)}`, { signal });
}

export async function askCowork(sessionId, message, { signal } = {}) {
  // POST /api/cowork/ask  ->  { jobId, sessionId, streamToken }
  // sessionId may be null/undefined; the server will create one.
  return apiFetch("/api/cowork/ask", {
    method: "POST",
    body: { sessionId: sessionId || undefined, message },
    signal,
  });
}

export function getStreamToken() {
  return getAuthToken();
}
